var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M19,7H11V14H3V5H1V20H3V17H21V20H23V11A4,4 0 0,0 19,7M7,13A3,3 0 0,0 10,10A3,3 0 0,0 7,7A3,3 0 0,0 4,10A3,3 0 0,0 7,13Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }